import FakeInput from "@edaz/edazkit/controls/FakeInput";
import { Check } from "@frui.ts/bootstrap";
import type { ViewComponent } from "@frui.ts/views";
import FeeType from "entities/feeType";
import { observer } from "mobx-react-lite";
import React from "react";
import { Col, Form } from "react-bootstrap";
import { formatAmount, translateEnum } from "utils/localizations";
import type CustomerRefundCandidateDetailViewModel from "viewModels/finance/customerRefunds/customerRefundCandidates/customerRefundCandidateDetailViewModel";
import type RejectedCustomerRefundCandidateDetailViewModel from "viewModels/finance/customerRefunds/rejectedCustomerRefundCandidates/rejectedCustomerRefundCandidateDetailViewModel";

const PayGateRefundSection: ViewComponent<
  CustomerRefundCandidateDetailViewModel | RejectedCustomerRefundCandidateDetailViewModel
> = observer(({ vm }) => {
  return (
    <Form.Row>
      <Form.Group as={Col} xl={6}>
        <Form.Label>{translateEnum("feeType", FeeType.ChargeRefundFee)}</Form.Label>
        <FakeInput target={vm} property="chargeRefundFee" valueFormatter={formatAmount} />
      </Form.Group>
      <Form.Group as={Col} xl={6}>
        <Check
          className="mt-6 mb-3"
          target={vm.item}
          property="isWithoutRefundFee"
          disabled={!vm.isEditable || !vm.isUserAllowedToEdit}
          custom
          label={<span>{vm.translateAttribute("isWithoutRefundFee")}</span>}
        />
      </Form.Group>
      <Form.Group as={Col} xl={6}>
        <Form.Label>{vm.translateAttribute("refundAmount")}</Form.Label>
        <FakeInput target={vm.item} property="refundAmount" valueFormatter={formatAmount} />
      </Form.Group>
      <Form.Group as={Col} xl={6}>
        <Form.Label>{vm.translateAttribute("officialRecordId")}</Form.Label>
        <FakeInput target={vm.item} property="officialRecordId" />
      </Form.Group>
    </Form.Row>
  );
});

export default PayGateRefundSection;
